<template>
  <iframe class="iframe_box" frameborder="0" src="https://yq.cailian.net/views/online_training/index.jsp?ptxtoken=ibF1uueLWdAN57q9"></iframe>
</template>
<script>
export default {
  data(){
    return{}
  },
  mounted(){}
}
</script>
<style lang="scss" scoped>
 .iframe_box{
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    display: block;
 }
</style>


// WEBPACK FOOTER //
// src/components/views/iframe/iframe.vue